import React, { useState, useEffect } from "react";
import axios from "axios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTableR";
import { formatMoneda } from "../../../util/varios";
import moment from "moment";
import { ConsultarDeuda } from "./modalConsultarDeuda";
import { SearchInput } from "../../../ui/inputs/Input";

const headCells = [
  {
    id: "idcomercio",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "ritm",
    label: "RITM",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "rif",
    label: "RIF",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "nombre",
    label: "NOMBRE",
    width: "300px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "codigocatastral",
    label: "CÓDIGO CATASTRAL",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaDeudaspp(props) {
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();
  const [detalle, setDetalle] = useState();
  const [deuda, setDeuda] = useState();
  const [history, setHistory] = useState();
  const [recargo, setRecargo] = useState();
  const [valorut, setValorut] = useState();
  const [total, setTotal] = useState(0.0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [factorCambio, setFactorCambio] = useState(0);
  const [operacion, setOperacion] = useState(0);
  const [espiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idcomercio.includes(target.value) === null
                ? ""
                : x.idcomercio.includes(target.value)) ||
              (x.ritm === null
                ? ""
                : x.ritm.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.rif === null
                ? ""
                : x.rif.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.nombre === null
                ? ""
                : x.nombre.toLowerCase().includes(target.value.toLowerCase()))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let campos = "idcomercio, ritm, rif, nombre, direccion, status";
    let nomtab = "comercio";
    let orden = "idcomercio desc";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistro = (idcomercio) => {
    let campos = "*";
    let nomtab = "comercio";
    let nomid = "idcomercio";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcomercio}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcomercio > 0) {
            setComercio(response.data);
            seleccionarRegistroPersona(response.data);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarFactorCambio = () => {
    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setFactorCambio(response.data.valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setActivate(false);
    setComercio();
    setPersona();
    setDetalle();
    setDeuda();
  };

  const seleccionarRegistroPersona = (data) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.reprelegal}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.cedula > 0) {
            setPersona(response.data);
            seleccionarDeuda(data);
          } else {
            seleccionarDeuda(data);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarDeuda = (data) => {
    let nomtab = "publicidad";
    let idcom = "idcomercio";
    let endpoint = `${op.conexion}/api/publicidad/consultadeuda?nomtab=${nomtab}&nomid=${idcom}&id=${data.idcomercio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            var mes;
            var respuesta = [];
            var history = [];
            var mas = 0.0;
            var desc = 0.0;
            var total = 0.0;
            for (var i = 0; i < response.data.length; i++) {
              var mm =
                response.data[i].fechainscripcion === null
                  ? 0
                  : parseInt(
                      moment
                        .utc(response.data[i].fechainscripcion)
                        .format("YYYY-MM-DD")
                        .substring(5, 7),
                    );
              switch (mm) {
                case 1:
                  mes = "ENERO";
                  break;
                case 2:
                  mes = "FEBRERO";
                  break;
                case 3:
                  mes = "MARZO";
                  break;
                case 4:
                  mes = "ABRIL";
                  break;
                case 5:
                  mes = "MAYO";
                  break;
                case 6:
                  mes = "JUNIO";
                  break;
                case 7:
                  mes = "JULIO";
                  break;
                case 8:
                  mes = "AGOSTO";
                  break;
                case 9:
                  mes = "SEPTIEMBRE";
                  break;
                case 10:
                  mes = "OCTUBRE";
                  break;
                case 11:
                  mes = "NOVIEMBRE";
                  break;
                case 12:
                  mes = "DICIEMBRE";
                  break;
              }
              if (!response.data[i].cancelada) {
                mas = parseFloat(response.data[i].monto);
                desc = desc + mas;
                total = formatMoneda(
                  desc.toString().replace(".", ","),
                  ",",
                  ".",
                  2,
                );

                respuesta.push({
                  idpublicidad: response.data[i].idpublicidad,
                  idcomercio: response.data[i].idcomercio,
                  idtipopublicidad: response.data[i].idtipopublicidad,
                  ancho: response.data[i].ancho,
                  alto: response.data[i].alto,
                  cantidad: response.data[i].cantidad,
                  monto: response.data[i].monto,
                  anio: response.data[i].anio,
                  cancelada: response.data[i].cancelada,
                  fechainscripcion: response.data[i].fechainscripcion,
                  ubicacion: response.data[i].ubicacion,
                  fechapago: response.data[i].fechapago,
                  numerorecibo: response.data[i].numerorecibo,
                  reccroquisubi: response.data[i].reccroquisubi,
                  recplanoestructura: response.data[i].recplanoestructura,
                  recautpropieinmue: response.data[i].recautpropieinmue,
                  recautinsvialreg: response.data[i].recautinsvialreg,
                  recusoconfddu: response.data[i].recusoconfddu,
                  descripcion: response.data[i].descripcion,
                  codigoordenanza: response.data[i].codigoordenanza,
                  mes: mes,
                });
              } else {
                total = mas;
                history.push({
                  idpublicidad: response.data[i].idpublicidad,
                  idcomercio: response.data[i].idcomercio,
                  idtipopublicidad: response.data[i].idtipopublicidad,
                  ancho: response.data[i].ancho,
                  alto: response.data[i].alto,
                  cantidad: response.data[i].cantidad,
                  monto: response.data[i].monto,
                  anio: response.data[i].anio,
                  cancelada: response.data[i].cancelada,
                  fechainscripcion: response.data[i].fechainscripcion,
                  ubicacion: response.data[i].ubicacion,
                  fechapago: response.data[i].fechapago,
                  numerorecibo: response.data[i].numerorecibo,
                  reccroquisubi: response.data[i].reccroquisubi,
                  recplanoestructura: response.data[i].recplanoestructura,
                  recautpropieinmue: response.data[i].recautpropieinmue,
                  recautinsvialreg: response.data[i].recautinsvialreg,
                  recusoconfddu: response.data[i].recusoconfddu,
                  descripcion: response.data[i].descripcion,
                  codigoordenanza: response.data[i].codigoordenanza,
                  mes: mes,
                });
              }
            }
            setDeuda(respuesta);
            setHistory(history);
            setTotal(total);
            setMostrar5(true);
          } else {
            setMostrar5(true);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarConfiguracion = () => {
    let campos = "*";
    let nomtab = "configindustria";
    let orden = "1";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecargo(response.data[0]);
          if (response.data[0].factorcalculo !== null) {
            SelectValorUT(response.data[0].factorcalculo);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectValorUT = (factorcalculo) => {
    let tipo = (factorcalculo = 3).toString();
    let m = parseInt(fechaSistema.substring(6, 8));
    let a = parseInt(fechaSistema.substring(1, 5));
    var descripcion = "";
    descripcion =
      tipo === "0"
        ? "Petros"
        : tipo === "1"
          ? "Sueldo Minimo"
          : tipo === "2"
            ? "UCAMP"
            : "";
    let endpoint = `${op.conexion}/api/publicidad/valorut?factorcalculo=${factorcalculo}&anio=${a}&mes=${m}&espiritu=${espiritu}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setValorut(response.data[0].valor);
          } else {
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const consultarPP = (ope, id) => (event) => {
    event.preventDefault();
    blanquear();
    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
    } else if (ope === 4) {
      setOperacion(4);
      seleccionarRegistro(id);
    } else if (ope === 2) {
      setOperacion(2);
      seleccionarRegistro(id);
    } else if (ope === 3) {
      setOperacion(3);
      seleccionarRegistro(id);
    }
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarConfiguracion();
    seleccionarFactorCambio();
  }, []);

  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">
          Gestion de Detalle de Deuda de Propaganda y Publicidad
        </h3>
        <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-4 m-0 my-2 p-0">
        <SearchInput placeholder="Buscar" onChange={handleSearch} />
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idcomercio} style={{ padding: "0" }}>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10px",
                    }}
                  >
                    {item.idcomercio}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "80px",
                    }}
                  >
                    {item.ritm}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "80px",
                    }}
                  >
                    {item.rif}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "left",
                      width: "auto",
                    }}
                  >
                    {item.nombre}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "auto",
                    }}
                  >
                    {item.codigocatastral}
                  </td>
                  <td
                    align="center"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "150px",
                    }}
                  >
                    <button
                      onClick={consultarPP(4, item.idcomercio)}
                      className="btn btn-info btn-sm  btn-sm rounded-pill"
                    >
                      <i className="fas fa-eye"></i>Consultar
                    </button>
                    <a> &nbsp; </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <ConsultarDeuda
        factorCambio={factorCambio}
        show={mostrar5}
        comercio={comercio}
        persona={persona}
        detalle={detalle}
        deuda={deuda}
        valorut={valorut}
        history={history}
        total={total}
        recargo={recargo}
        onHideRenderizar={seleccionarRegistro}
        onHideCancela={cerrarModalActualizar}
        operacion={operacion}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}

export default TablaDeudaspp;
